// extracted by mini-css-extract-plugin
module.exports = {"BILL_DELIVER":"BILL_DELIVER-c642408485232ae70b48c04395bf024b","reviewBtn":"reviewBtn-5820a136d0b905ab1a63279dc024e9f9"};